import { render, staticRenderFns } from "./c-input-area.vue?vue&type=template&id=357dd376&"
import script from "./c-input-area.vue?vue&type=script&lang=js&"
export * from "./c-input-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports